const cuentas = {
  C001Usuarios: 'Cuentas/Usuarios/GetUsuarios',
  C001Jueces: 'Cuentas/Usuarios/GetJueces'
}

export default cuentas;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/Cuentas/Usuarios/cuentas.js
// module id = null
// module chunks = 